import { DismissData } from "../types";

const SOFTWALL_DISMISSED_KEY = "BT_AM_SOFTWALL_DISMISSED";

export const getDismissData = (): DismissData | undefined => {
  const dismissDataStr = sessionStorage.getItem(SOFTWALL_DISMISSED_KEY);
  if (dismissDataStr) {
    try {
      return JSON.parse(dismissDataStr);
    } catch (e) {
      console.error(e);
    }
  }
};

export const hasDismissedData = () =>
  sessionStorage.getItem(SOFTWALL_DISMISSED_KEY) !== null;

export const saveDismissData = (dismissData: DismissData) =>
  sessionStorage.setItem(SOFTWALL_DISMISSED_KEY, JSON.stringify(dismissData));

export const deleteDismissedData = () =>
  sessionStorage.removeItem(SOFTWALL_DISMISSED_KEY);
